import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteConfigShippingZoneProps extends ModalEditComponentProps { }

const ModalDeleteConfigShippingZone: React.FC<ModalDeleteConfigShippingZoneProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit, url: '/api/app/config/shipping/shippingZone/deleteShippingZone',
        data: {
            country: allRowData?.country,
            postal_code: allRowData?.postal_code,
            state: allRowData?.state,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteZone', '¿Seguro quieres eliminar esta zona?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteConfigShippingZone